import * as React from "react";
import type { SVGProps } from "react";
export const SvgLolCustomProfile = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="currentColor" viewBox="0 0 16 16" {...props}>
    <path d="M9.334 9.501v1.394A4.001 4.001 0 0 0 4 14.667H2.667A5.333 5.333 0 0 1 9.334 9.5ZM8 8.667c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4Zm0-1.334A2.666 2.666 0 1 0 8 2a2.666 2.666 0 1 0 0 5.333Zm4 4v-2h1.334v2h2v1.334h-2v2H12v-2h-2v-1.334h2Z" />
  </svg>
);
